module.exports = __webpack_public_path__ + "img/ico-gateway.9584f1b4.svg";